import client from './client';

export const getPlugins = async () => {
  const response = await client.get('/api/plugins');
  return response.data;
};

export const getPlugin = async (name) => {
  const response = await client.get(`/api/plugins/${name}`);
  return response.data;
};

export const enablePlugin = async (name) => {
  const response = await client.post(`/api/plugins/${name}/enable`);
  return response.data;
};

export const disablePlugin = async (name) => {
  const response = await client.post(`/api/plugins/${name}/disable`);
  return response.data;
};

export const updatePluginConfig = async (name, config) => {
  const response = await client.put(`/api/plugins/${name}/config`, config);
  return response.data;
};
